var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 110946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.96817 2.17383H2.10404C1.81123 2.17383 1.53041 2.29015 1.32336 2.49719C1.11632 2.70424 1 2.98506 1 3.27787V11.0061C1 11.2989 1.11632 11.5798 1.32336 11.7868C1.53041 11.9938 1.81123 12.1102 2.10404 12.1102H9.8323C10.1251 12.1102 10.4059 11.9938 10.613 11.7868C10.82 11.5798 10.9363 11.2989 10.9363 11.0061V7.142",
    stroke: "#B7CF53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1087 1.34298C10.3283 1.12337 10.6262 1 10.9367 1C11.2473 1 11.5451 1.12337 11.7648 1.34298C11.9844 1.56259 12.1077 1.86044 12.1077 2.17101C12.1077 2.48158 11.9844 2.77943 11.7648 2.99904L6.52057 8.24321L4.3125 8.79523L4.86452 6.58716L10.1087 1.34298Z",
    stroke: "#B7CF53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteMessage);
export default __webpack_public_path__ + "static/media/write-message.06bf3cb2.svg";
export { ForwardRef as ReactComponent };